export const LOAD_CONTROL_INGRESOS = 'LOAD_CONTROL_INGRESOS';
export const SET_CONTROL_INGRESOS = 'SET_CONTROL_INGRESOS';
export const SAVE_CONTROL_INGRESO = 'SAVE_CONTROL_INGRESO';
export const SAVED_CONTROL_INGRESO = 'SAVED_CONTROL_INGRESO';

export const loadControlIngresos = () => ({
    type: LOAD_CONTROL_INGRESOS,
});

export const setControlIngresos = (ingresos) => ({
    type: SET_CONTROL_INGRESOS,
    ingresos,
});

export const saveControlIngreso = (ingreso) => ({
    type: SAVE_CONTROL_INGRESO,
    ingreso,
});

export const savedControlIngreso = (ingreso) => ({
    type: SAVED_CONTROL_INGRESO,
    ingreso,
});

const initialState = {
    ingresos: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case SET_CONTROL_INGRESOS: {
        return { ...state, ingresos: action.ingresos };
    }
    case SAVED_CONTROL_INGRESO: {
        const { ingreso } = action;
        const index = state.ingresos.findIndex((item) => item.id === ingreso.id);
        if (index === -1) {
            return { ...state, ingresos: state.ingresos.concat(ingreso) };
        }
        const updated = state.ingresos
            .slice(0, index)
            .concat([ingreso])
            .concat(state.ingresos.slice(index + 1));
        return { ...state, ingresos: updated };
    }
    default:
        return state;
    }
};
